// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Link } from 'react-router';
import { MUILink } from '../../../lib/base';

export function BetterLinkUnderline({
  children,
  to,
  external = false,
}: {
  readonly children: React.ReactNode;
  readonly to: string;
  readonly external?: boolean;
}): React.ReactElement {
  const isExternal = external;

  return (
    <MUILink
      component={isExternal ? 'a' : Link}
      to={isExternal ? undefined : to}
      href={isExternal ? to : undefined}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      sx={{
        color: 'primary.contrastText',
        position: 'relative',
        textDecoration: 'none',
        py: 0.1,
        display: 'block',
        width: 'fit-content',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          height: '1px',
          bgcolor: 'primary.contrastText',
          transform: 'scaleX(0)',
          transition: 'transform 0.2s ease-in-out',
          transformOrigin: 'left center',
        },
        '&:hover::after': {
          transform: 'scaleX(1)',
        },
      }}
    >
      {children}
    </MUILink>
  );
}
